<template>
	<div class="login-row">
		<select
			v-if="userStore.isLoggedIn"
			class="theme-dropdown"
			title="Site theme"
			:value="userStore.profile?.theme || ''"
			@change="onThemeChange(($event.target as HTMLSelectElement).value)"
		>
			<option value="">Default</option>
			<option v-for="t in themes" :key="t.value" :value="t.value">{{ t.label }}</option>
		</select>
		<ScifiButton
			:text="getLoginLabel()"
			:buttonType="userStore.isLoggedIn ? 'negative' : 'positive'"
			minWidth="100px"
			style="white-space: nowrap;"
			@click="toggleLogin()"
		/>
		<img
			v-if="userStore.isLoggedIn"
			class="profile-avatar"
			:src="getUserPhoto()"
			referrerPolicy="no-referrer"
			@click="toggleProfile()"
		/>
	</div>
</template>

<script setup lang="ts">
	// <q-icon v-else ref="icon" style="margin-left: 16px" :name="getUserPhoto()"/>
	import { ref, onMounted } from 'vue';
	import { useUserStore } from '../stores/user';
	import { getAuth, onAuthStateChanged } from 'firebase/auth';
	import { userInfo2UserState, THEMES } from '../models/user';

	const themes = THEMES;
	const onThemeChange = async (v: string) => {
		if (!userStore.profile) return;
		userStore.profile.theme = (v || null) as any; // reactive apply via app.vue watcher
		try {
			const { $firestore } = useNuxtApp();
			const { doc, setDoc } = await import('firebase/firestore');
			await setDoc(doc($firestore as any, '/users', userStore.profile.uid), userStore.profile);
		} catch (e) {
			console.error('Theme save failed', e);
		}
	};

	const button = ref(null);
	const icon = ref(null);
	const rotate = ref(true);
	const userStore = useUserStore();

	const handleMouseOver = () => {
		if (rotate.value == false) {
			rotate.value = true;
			setTimeout(() => {
				rotate.value = false;
			}, 3000);
		}
	};

	const toggleLogin = async () => {
		if (!userStore.isLoggedIn) {
			navigateTo('/login');
		} else {
			await userStore.logout();
			navigateTo('/');
		}
	};

	const toggleProfile = async () => {
		userStore.toggleProfile();
	};

	const getLoginLabel = () => {
		if (!userStore.isLoggedIn) {
			return 'LOGIN';
		} else {
			return 'LOG OUT';
		}
	};

	const getUserPhoto = () => {
		if (userStore.profile?.photoURL !== '') {
			return `${userStore.profile?.photoURL}`;
		} else {
			return '/svg/cybercore_trans.svg';
		}
	};

	onBeforeMount(async () => {
		const auth = getAuth();
		onAuthStateChanged(auth, async (user) => {
			if (user != null) {
				userStore.setUser(userInfo2UserState(user));
			}
		});
	});

	onMounted(() => {
		rotate.value = true;
		setTimeout(() => {
			rotate.value = false;
		}, 5000);
	});
</script>

<style scoped>
	.login-row {
		display: flex;
		align-items: center;
		gap: 8px;
	}

	.theme-dropdown {
		background: #0a1418;
		border: 1px solid #00ffea40;
		border-radius: 4px;
		color: #00ffea;
		font-family: 'Share Tech Mono', 'Courier New', monospace;
		font-size: 0.8em;
		padding: 6px 8px;
		max-width: 150px;
		cursor: pointer;
		outline: none;
		transition: border-color 0.2s;
	}

	.theme-dropdown:hover {
		border-color: #00ffea;
	}

	.theme-dropdown option {
		background: #0a1418;
		color: #00ffea;
	}

	.profile-avatar {
		width: 36px;
		height: 36px;
		border-radius: 50%;
		border: 1px solid #00ffea40;
		object-fit: contain;
		cursor: pointer;
		transition: border-color 0.2s;
	}

	.profile-avatar:hover {
		border-color: #00ffea;
	}
</style>
